export default __webpack_public_path__ + "static/media/SFProDisplay-Medium.7274e74c.woff";